<template>
  <el-tooltip
    :content="tipInfo"
    placement="bottom"
    effect="light"
    :visible-arrow="false"
    popper-class="pop_box"
  >
    <img
      :src="bleSignalPic"
      class="Ble_signal_pic"
    > 
  </el-tooltip>
</template>

<script>
import Ble1 from "@/assets/img/deviceicon/Ble_signal_pic1.png";
import Ble2 from "@/assets/img/deviceicon/Ble_signal_pic2.png";
import Ble3 from "@/assets/img/deviceicon/Ble_signal_pic3.png";
export default {
  name:'DeviceSignal',
  props:{
    max:{
      type:Number,
      default:0
    },
    min:{
      type:Number,
      default:0
    },
    title:{
      type:String,
      default:''
    },
    value:{
      type:Number,
      default:0
    }
  },
  data(){
    return {
      bleSignalPic:''
    }
  },
  computed:{
    tipInfo: function(){
      let str = this.title + ':' + this.value +"dBm"
      return str
    }
  },
  created(){
    this.initPic()
  },
  methods:{
    initPic(){
      if(this.value<-75){
        this.bleSignalPic = Ble1
      }else if(this.value>=-75 && this.value<=-60){
        this.bleSignalPic = Ble2
      }else{
        this.bleSignalPic = Ble3
      }
    }
  }
}
</script>

<style scoped>
.Ble_signal_pic{
	margin-right: 4px;
	width: 20px;
	height: 12px;
}
</style>
<style>
.pop_box{
  height: 6px;
  line-height: 6px;
  background-color:  #DFDEE1 !important;
  border: 0 !important;
  border-radius: 2px;
}
</style>
